import {
  isMultiboxSelector,
  parcelSelector,
  updateParcel,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {FEDEX, SHIPPO} from '../../../common/constants/ShipperNames.js'
import {useSelector} from '../../../store.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [FEDEX, SHIPPO]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`packages[0].${shipperType}__sub_package_type`]
    : []
}

export default function SubPackageType({packagesIndex}) {
  packagesIndex = packagesIndex || 0
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = SubPackageType.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(shipperType)

  let {[`${shipperType}__sub_package_type`]: subPackageType} = useSelector(
    (state) => parcelSelector(state, {labelInfoID, packagesIndex}),
  )

  const isMultibox = useSelector((state) =>
    isMultiboxSelector(state, {labelInfoID, shipperType}),
  )

  return (
    <ConfigSelect
      label="Sub-Package Type"
      value={subPackageType || ''}
      onChange={(value) => {
        updateParcel(labelInfoID, packagesIndex, {
          [`${shipperType}__sub_package_type`]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="sub_package_type"
      hide={isMultibox}
    />
  )
}

SubPackageType.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
